import { formatCurrency } from '../../utils/datetime';
import { useWorkspaceSales } from '../../hooks/useWorkspaceSales';

const weekday = (dateKey) =>
  new Date(`${dateKey}T12:00:00`).toLocaleDateString(undefined, { weekday: 'short' });

const ReportsOverview = () => {
  const { data, loading, error } = useWorkspaceSales();
  const currency = data?.currency || 'GHS';
  const reports = data?.reports;
  const daily = reports?.daily || [];
  const maxRevenue = Math.max(...daily.map((d) => d.revenue), 1);

  const stats = [
    { label: 'Collected (7 days)', value: formatCurrency(reports?.collected || 0, currency) },
    { label: 'Visits completed', value: String(reports?.visitsCompleted || 0) },
    { label: 'Paid out', value: formatCurrency(data?.paidOut || 0, currency) },
    { label: 'Awaiting payout', value: formatCurrency(data?.pendingAmount || 0, currency) },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Overview</h2>
        <p className="mt-1 text-sm text-ink-700/80">{reports?.periodLabel || 'Last 7 days'}</p>
      </div>

      {error && (
        <div className="border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">{error}</div>
      )}

      {loading ? (
        <div className="flex justify-center py-16">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-ink-900/20 border-t-saffron-500" />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label} className="bg-sand-50 px-4 py-4 ring-1 ring-ink-900/10 sm:px-5">
                <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/60">
                  {item.label}
                </p>
                <p className="mt-2 font-display text-2xl font-light tracking-tight text-ink-900 sm:text-3xl">
                  {item.value}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-sand-50 p-5 ring-1 ring-ink-900/10 sm:p-6">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-600/60">
              Daily collections
            </p>
            <div className="mt-6 flex h-40 items-end gap-2 sm:gap-3">
              {daily.map((day) => (
                <div key={day.dateKey} className="flex min-w-0 flex-1 flex-col items-center gap-2">
                  <div className="flex w-full flex-1 items-end">
                    <div
                      className="w-full bg-saffron-500 transition-all"
                      style={{
                        height: `${Math.max((day.revenue / maxRevenue) * 100, day.revenue ? 6 : 2)}%`,
                      }}
                      title={formatCurrency(day.revenue, currency)}
                    />
                  </div>
                  <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-ink-600/60">
                    {weekday(day.dateKey)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ReportsOverview;
